import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "../../store";
import Fallback from "../../components/atoms/fallback";
import {
  roleAccessMatchers,
  tabletAccessMatchers,
} from "../../helpers/permission";
import Forbidden from "../../components/forbidden";
import { useIsTablet } from "@hooks/use-is-tablet";

const PrivateRoute = () => {
  const { loading } = useSelector((state: RootState) => state.auth);
  const refreshToken = localStorage.getItem("refreshToken");
  const accessToken = localStorage.getItem("accessToken");
  const location = useLocation();
  const currentPath = location.pathname;
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const isTablet = useIsTablet();

  if (!refreshToken || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  if (!role) return;
  if (loading) return <Fallback />;

  const roleFormatted = encodeURIComponent(role as string);
  const matchers = roleAccessMatchers[roleFormatted] ?? [];
  const hasRoleAccess = matchers.some((regex) => regex.test(currentPath));

  if (!hasRoleAccess) {
    return <Forbidden />;
  }

  if (isTablet) {
    const hasTabletAccess = tabletAccessMatchers.some((regex) =>
      regex.test(currentPath),
    );
    if (!hasTabletAccess) {
      return <Forbidden />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
